import ro from './ro';
import hu from './hu';
import en from './eng';

const translations = {
  ro,
  hu,
  en,
};

export default translations;
